import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]

  connect() {
    const firstButton = this.buttonTargets[0]
    if (firstButton) {
      const panelId = firstButton.dataset.tabsPanelId
      if (panelId) {
        this.showPanel(panelId)
      }
    }
  }

  switch(event) {
    event.preventDefault()
    const panelId = event.currentTarget.dataset.tabsPanelId
    if (panelId) {
      this.showPanel(panelId)
    }
  }

  showPanel(panelId) {
    if (!panelId) return

    this.buttonTargets.forEach(button => {
      const buttonPanelId = button.dataset.tabsPanelId
      if (buttonPanelId === panelId) {
        button.classList.add("active", "text-blue-600", "border-blue-600", "bg-blue-50/50")
        button.classList.remove("text-gray-600", "border-transparent", "bg-transparent")
      } else {
        button.classList.remove("active", "text-blue-600", "border-blue-600", "bg-blue-50/50")
        button.classList.add("text-gray-600", "border-transparent", "bg-transparent")
      }
    })

    this.panelTargets.forEach(panel => {
      const panelIdAttr = panel.dataset.tabsPanelId
      if (panelIdAttr === panelId) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}

